<template>
  <div class="ima-sign-thumbnail" @mouseover="onMouseOver" @mouseout="onMouseOut">
    <div v-if="!hasThumbnail" class="ima-sign-thumbnail__placeholder">Keine Vorschau verfügbar</div>
    <figure v-if="hasThumbnail" class="image" :class="`is-${this.width}x${this.height}`">
      <img :src="getThumbnailUrl(this.width, this.height)" />
    </figure>
    <figure v-if="hasThumbnail && previewIsVisible" class="box ima-sign-thumbnail__preview">
      <img :src="getThumbnailUrl(480, 480)" width="480" height="480" />
    </figure>
  </div>
</template>


<script>
export default {
  name: 'ima-sign-thumbnail',
  props: {
    sign: {
      type: Object,
      required: true
    },
    width: {
      type: Number,
      default: 64
    },
    height: {
      type: Number,
      default: 64
    }
  },
  data () {
    return {
      previewIsVisible: false
    }
  },
  computed: {
    defaultVariant () {
      return (
        this.sign.variants &&
        this.sign.variants.find(
          ({ isDefault, isPublished }) => isDefault && isPublished
        )
      )
    },
    hasThumbnail () {
      return !!(this.defaultVariant && this.defaultVariant.filePath)
    }
  },
  methods: {
    onMouseOver () {
      this.previewIsVisible = true
    },
    onMouseOut () {
      this.previewIsVisible = false
    },
    getThumbnailUrl (width = 64, height = 64) {
      if (this.hasThumbnail) {
        return `${SERVER_URL}/assets/thumbnails/${
          this.defaultVariant.filePath
        }_${width}x${height}.png`
      }
      return null
    }
  }
}
</script>


<style lang="scss">
@import '../scss/settings';

.ima-sign-thumbnail {
  user-select: none;

  &__preview {
    display: none;
  }

  &:hover > .ima-sign-thumbnail__preview {
    display: block;
    position: fixed;
    height: auto;
    width: 480px;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
    pointer-events: none;
    filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.2));
    z-index: 1;
  }

  &__placeholder {
    background: #eaeaea;
    text-transform: uppercase;
    font-size: 0.55rem;
    color: #b5b5b5;
    width: 64px;
    height: 64px;
    text-align: center;
    padding-top: 0.85rem;
    border: 1px solid #dedddd;
  }

  &__preview {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignThumbnail.vue